import { ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export interface Fields {
  data?: {
    footer?: N06MainFooter;
  };
}

export interface N06MainFooterLinkItem {
  id?: string;
  link?: {
    jsonValue?: LinkField;
  };
}

export interface N06MainFooterColumn {
  id?: string;
  heading?: {
    jsonValue?: {
      value?: string;
    };
  };
  footerLinkItems?: {
    results?: N06MainFooterLinkItem[];
  };
}

export interface SocialMediaLink {
  type?: {
    jsonValue?: {
      id?: string;
      url?: string;
      name?: string;
      displayName?: string;
      fields?: {
        Value?: {
          value?: string;
        };
        Key?: {
          value?: string;
        };
      };
    };
  };
  link?: {
    jsonValue?: LinkField;
  };
}

export interface N06MainFooter {
  logo?: {
    jsonValue?: ImageField;
  };
  logoLink?: {
    jsonValue?: LinkField;
  };
  socialMediaLinks?: {
    targetItems?: SocialMediaLink[];
  };
  bottomRichText?: {
    jsonValue?: {
      value?: string;
    };
  };
  legalSection1Copy?: {
    jsonValue?: {
      value?: string;
    };
  };
  copyrightText?: {
    jsonValue?: {
      value?: string;
    };
  };
  legalSection2Copy?: {
    jsonValue?: {
      value?: string;
    };
  };
  footerColumns?: {
    results?: N06MainFooterColumn[];
  };
}
